'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const SeoLink = require('./SeoLink');

const SeoLinks = props => (
    <div className="seo-links">
        <div className="header-primary-large seo-links-title">More Ways To Browse</div>
        <ul className="seo-links-inner rowFlex">
            {props.links.map(link => <SeoLink key={link.url} link={link} />)}
        </ul>
    </div>
);

SeoLinks.propTypes = {
    links: PropTypes.array.isRequired,
};

module.exports = SeoLinks;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/SeoLinks/SeoLinks.jsx